import { formatMoney, formatRate } from '../../utils/formatOpportunityValues';
export const crossSellEvidenceLines = (evidence, texts, locale)=>[
        texts.peerAdoption({
            rate: formatRate(evidence.peerAdoptionRate, locale),
            template: evidence.templateName
        }),
        texts.peerClientCount({
            count: evidence.peerClientCount
        }),
        texts.avgTemplateAmount({
            amount: formatMoney(evidence.avgTemplateAmount, locale)
        })
    ];
